<template>
  <div class="wm" aria-hidden="true">
    <div
      v-for="n in tiles"
      :key="n"
      class="wm-item"
    >
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'SiteWatermark',
  props: {
    text: {
      type: String,
      default: '算力百科 全国首个算力和大模型工程服务 IP'
    }
  },
  computed: {
    tiles() {
      return 24
    }
  }
}
</script>

<style scoped>
.wm {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 80px 40px;
  padding: 40px 20px;
  opacity: 0.07;
}

.wm-item {
  color: #1d2129;
  font-size: 14px;
  white-space: nowrap;
  transform: rotate(-24deg);
  user-select: none;
}
</style>
